import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "x-query-layout"
};
const _hoisted_2 = {
  class: "x-query-toolbar"
};
const _hoisted_3 = {
  class: "x-query-header"
};
import { XLayout, XLayoutHeader, XLayoutContent, XLayoutFooter, XSplit, XSplitPane, XDrawer } from '@xui/components';
import { reactive, toRefs, watch } from 'vue';
export default {
  __name: 'xqueryLayout',
  props: {
    showLeftPane: {
      type: Boolean,
      default: true
    },
    showDrawer: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:showDrawer', 'update:showLeftPane'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const state = reactive({
      showLeftPane: false
    });
    const {
      showLeftPane,
      showDrawer
    } = toRefs(props);
    const handleDrawerVisible = visible => {
      emit('update:showDrawer', visible);
    };
    watch(showLeftPane, val => {
      state.showLeftPane = val;
    }, {
      immediate: true
    });
    __expose({
      setLeftPaneVisible: visible => {
        console.log('setLEftPaneVisible:', visible);
        emit('update:showLeftPane', visible);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(XLayout), {
        vertical: ""
      }, {
        default: _withCtx(() => [_createVNode(_unref(XLayoutHeader), {
          fixed: ""
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "toolbar")]), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "header", {}, () => [_cache[0] || (_cache[0] = _createTextVNode("页头", -1))])])]),
          _: 3
        }), _createVNode(_unref(XLayoutContent), {
          class: "x-query-content"
        }, {
          default: _withCtx(() => [_createVNode(_unref(XSplit), {
            height: "100%"
          }, {
            default: _withCtx(() => [state.showLeftPane ? (_openBlock(), _createBlock(_unref(XSplitPane), {
              key: 0,
              width: "200px"
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
                style: {
                  "background-color": "red"
                }
              }, " 左栏内容 ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_unref(XSplitPane), {
              "show-action": ""
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" 右栏内容 ", -1)]))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_unref(XLayoutFooter), null, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("div", {
            class: "x-query-footer"
          }, "页脚", -1)]))]),
          _: 1
        })]),
        _: 3
      }), _createVNode(_unref(XDrawer), {
        width: "300px",
        visible: _unref(showDrawer),
        "onUpdate:visible": handleDrawerVisible,
        "show-footer": "",
        "show-confirm-button": ""
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createElementVNode("div", null, "抽屉内容", -1)]))]),
        _: 1
      }, 8, ["visible"])]);
    };
  }
};